import React from 'react'
import {Col} from 'react-bootstrap'
import { Eye, Github, Link45deg } from 'react-bootstrap-icons'

const ProjectCard = React.memo(({id, title, links, imgUrl, handleClick, className, animation = {} }) => {
    const handleShowProjectDetail = () => {
        handleClick(id, title, links)
    }
    return <Col sm={6} md={6} lg={4} xs={12} className={className} >
        <div className="proj-imgbx" {...animation}>
            <img src={imgUrl} alt="" />
            <div className="proj-txtx">
                <h4>{title}</h4>
                <div className="d-flex flex-row justify-content-center mt-3">
                    <span onClick={handleShowProjectDetail} className="me-3 proj-action">
                        <Eye size={25} />
                    </span>
                    {links.website && <a href={links.website} target='_blank' rel="noreferrer" className="text-white me-3 proj-action">
                        <Link45deg size={25} />
                    </a>}
                    {links.gitHub && <a href={links.gitHub} target="__blank" className="text-white proj-action">
                        <Github size={25} />
                    </a>}
                </div>
            </div>
        </div>
    </Col>
})
export default ProjectCard;